import { createApi } from '@reduxjs/toolkit/query/react'

import { baseQuery } from '@/redux/utils'

export interface License {
  id: number
  name: string
}

export const licenseSlice = createApi({
  reducerPath: 'license',
  baseQuery,
  endpoints: builder => ({
    readAllLicenses: builder.query<License[], void>({
      query: () => '/license/all',
    }),
  }),
})

export const {
  useReadAllLicensesQuery,
} = licenseSlice
